import React from 'react'
import injectSheet from 'react-jss'
import styles from './shared-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import SharedEntry from './shared-entry/shared-entry.container'
import {
  BulkActionProvider,
  SelectAllButton
} from 'pobble-components/dist/bulk-action'
import BulkAction from './bulk-action/bulk-action.container'

const SharedTable = ({ classes, presentations }) => (
  <BulkActionProvider entities={presentations}>
    <Table>
      <thead>
        <tr>
          <HeadCell className={classes.allCell}>
            <SelectAllButton />
          </HeadCell>
          <HeadCell className={classes.receivedCell}>Received</HeadCell>
          <HeadCell className={classes.fromCell}>From</HeadCell>
          <HeadCell className={classes.titleCell}>Title</HeadCell>
          <HeadCell className={classes.loCell}>Overview</HeadCell>
          <HeadCell>
            <BulkAction />
          </HeadCell>
        </tr>
      </thead>
      <tbody>
        {presentations.map(presentation => (
          <SharedEntry key={presentation.id} id={presentation.id} />
        ))}
      </tbody>
    </Table>
  </BulkActionProvider>
)

export default injectSheet(styles)(SharedTable)
